module.exports = __webpack_public_path__ + "static/img/bg2.4f1e93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/bg2.png
// module id = 3KYN
// module chunks = 1